import { gql } from "@apollo/client";

export const PREPARE_RESERVATION_GUEST_MUTATION = gql`
  mutation PrepareReservationGuest($input: PrepareReservationGuestInput!) {
    prepareReservationGuest(input: $input) {
      result {
        __typename
        ... on PrepareReservationGuestSuccess {
          preparationProof
          contact {
            id
            firstName
            lastName
            email
            mobilePhone
            mobilePhoneInternational
            phoneCountryCode
            phoneCountryDialCode
            phoneCountryName
            phoneCountryFormat
          }
        }
        ... on PrepareReservationGuestFailure {
          reason
        }
      }
    }
  }
`;
